export default {
    methods: {
        /*
        Takes as input an array with the uids of members of a list and
        the uid of the owner of the idea that will be published in the list.
        It returns an object with as property the uids of members of that list
        equal to true, except for the owner of the idea.
        */
        getMembersFromList: function (members, owner) {
            let userWaitingToEvaluate = {}
            let indexOwner = members.indexOf(owner);
            if (indexOwner > -1) {
                members.splice(indexOwner, 1);
            }
            for (let i = 0; i < members.length; i++) {
                userWaitingToEvaluate[members[i]] = true
            }
            return userWaitingToEvaluate;
        }
    }
};